// extracted by mini-css-extract-plugin
module.exports = {"appDownload":"app_badges-module--app-download--1WDGt","appBadges":"app_badges-module--app-badges--3zi8Z","atBottom":"app_badges-module--at-bottom--3Zjko"};